import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class BeginChallengeResponse
*  Если значение присутствует, то требуется подтвердить вход в систему<br>
*/
export class BeginChallengeResponse extends ActiveModel {

/**
  * challengeId
  * Идентификатор подтверждения<br>
  */
  @ActiveField('')
  challengeId: string = ''


/**
  * description
  * Дополнительное сообщение<br>
  */
  @ActiveField('')
  description: string = ''


  /**
  * retryMilliseconds
  * Через какое время (кол-во миллисекунд) можно повторно запросить<br>  */
  @ActiveField(0)
  retryMilliseconds: number = 0


  /**
  * lifetimeMilliseconds
  * В течении какого времени (кол-во миллисекунд) код подтверждения будет действовать<br>  */
  @ActiveField(0)
  lifetimeMilliseconds: number = 0


  /**
  * codeLength
  * Кол-во символов в коде подтверждения<br>  */
  @ActiveField(0)
  codeLength: number = 0
}
